import { Button } from '@pinpoint/ui/button';
import PropTypes from 'prop-types';
import { MarketingProductLink } from '../../analytics/marketingAnalyticsRuntime';

const PublicHeader = ({ hasSessionHint }) => {
    return (
        <header className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border">
            <div className="container mx-auto max-w-6xl px-6">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <a href="/" className="text-xl font-bold text-foreground">
                        Pinpoint Edu
                    </a>

                    {/* Navigation */}
                    <nav aria-label="Primary" className="flex items-center gap-3">
                        <Button
                            asChild
                            variant="ghost"
                            className="text-sm"
                        >
                            <a href="/demo">Demo</a>
                        </Button>
                        <Button
                            asChild
                            className="text-sm"
                        >
                            {hasSessionHint ? (
                                <MarketingProductLink
                                    aria-label="Go to practice"
                                    ctaId="header-practice"
                                    path="/practice"
                                >
                                    <span className="sm:hidden">Practice</span>
                                    <span className="hidden sm:inline">Go to practice</span>
                                </MarketingProductLink>
                            ) : (
                                <MarketingProductLink ctaId="header-login" path="/login">Log in</MarketingProductLink>
                            )}
                        </Button>
                    </nav>
                </div>
            </div>
        </header>
    );
};

PublicHeader.propTypes = {
    hasSessionHint: PropTypes.bool,
};

export default PublicHeader;
